import axios from "../../http/axios"
import { connect } from "@/pusher"

export default {
  SET_BEARER(state, accessToken) {
    // Set accessToken
    state.bearer = accessToken;
    localStorage.setItem("accessToken", accessToken)
    connect()
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
  }
}
